<template>
  <div class="board-box" :style="{width: canvasWidth + 'px', height: canvasHeight + 'px'}">
    <!-- 上传图片 -->
    <input type="file" accept="image/*" id="sketchpad-upload" ref="sketchpadUpload" @change="uploadImg($event)" >
    <!-- 工具列表 -->
    <ul class="tool-box" :class="{'tool-box--left': placement === 'left', 'tool-box--top': placement === 'top', 'tool-box--right': placement === 'right', 'tool-box--bottom': placement === 'bottom'}">
      <li v-for="item in tools" :key="item.type" class="tool-con" :class="{active: toolType === item.type}" @click="changeTool(item.type)">
        <label for="sketchpad-upload" v-if="item.type === 'upload'">
          <i class="iconfont" :class="item.icon"></i>
        </label>
        <i class="iconfont" v-else :class="item.icon"></i>
      </li>
    </ul>
    <!-- 画布 -->
    <canvas id="myCanvas" ref="myCanvas" ></canvas>
    <div class="flexible jc-between-end composeImg-btn mt24 mb20 mr24">
      <el-button @click="composeImg()" class="f16" type="success" size="medium">Confirm</el-button>
    </div>
  </div>
</template>

<script>
import { fabric } from 'fabric'
import FileSaver from 'file-saver'
import './index.scss'

let defaultProps = {
  canvasWidth: {
    type: Number,
    default: window.innerWidth
  },
  canvasHeight: {
    type: Number,
    default: window.innerHeight
  },
  canvasBgColor: {
    type: String,
    default: '#f6f6f6'
  },
  strokeColor: {
    type: String,
    default: '#000'
  },
  strokeWidth: {
    type: Number,
    default: 2
  },
  showTools: {
    type: Boolean,
    default: true
  },
  placement: {
    type: String,
    default: 'left'
  }
}

const TOOLS = [
  {
    name: '铅笔',
    type: 'pencil',
    icon: 'icon-pan_icon'
  },
  {
    name: '橡皮',
    type: 'rubber',
    icon: 'icon-xiangpi'
  },
  {
    name: '回退',
    type: 'undo',
    icon: 'icon-undo'
  },
  {
    name: '向前',
    type: 'redo',
    icon: 'icon-redo'
  },
  {
    name: '清除',
    type: 'clear',
    icon: 'icon-clear'
  },

]

export default {
  name: 'vue-fabric-sketchpad',
  data () {
    return {
      boardObj: null, // 存储当前画布对象
      mouseFrom: {}, // 鼠标按下的位置
      mouseTo: {}, // 鼠标抬起的位置
      toolType: 'pencil', // 当前工具类型
      isDrawing: false, // 是否正在画 鼠标按下和抬起的开关控制
      drawingObj: null, // 正在绘制的对象
      history: [], // 存放历史记录
      textObj: null, // 存储文字对象
      stage: 0,
      currImg: '',
      tools: TOOLS
    }
  },
  props: defaultProps,
  mounted () {
    this.boardObj = new fabric.Canvas('myCanvas', {
      isDrawingMode: true, // 是否可以自由绘制
      selectable: true, // 控件不能被选择
      selection: true, // 画板中是否显示选中
      devicePixelRatio: true
    })
    this.boardObj.freeDrawingBrush.color = this.strokeColor // 设置自由画笔的颜色
    this.boardObj.freeDrawingBrush.width = this.strokeWidth // 自由画笔的宽度
    this.boardObj.setWidth(this.canvasWidth)
    this.boardObj.setHeight(this.canvasHeight)
    this.initEvent()
  },
  methods: {
    initEvent () {
      this.boardObj.on({
        'mouse:down': (e) => {
          let { x, y } = e.pointer
          this.mouseFrom = { x, y }
          // 判断是否选中了对象
          if (!this.boardObj.getActiveObject()) {
            this.isDrawing = true
          }
          if (this.toolType === 'text') {
            this.drawText()
          }
        },
        'mouse:up': (e) => {
          let { x, y } = e.pointer
          this.mouseTo = { x, y }
          this.isDrawing = false
          this.drawingObj = null
          this.addHistory()
        },
        'mouse:move': e => {
          if (this.isDrawing) {
            let { x, y } = e.pointer
            this.mouseTo = { x, y }
            this.drawing()
          }
        },
        // 移动对象时触发该事件
        'object:moving': e => {
        },
        // 放大或者缩小对象时触发该事件
        'object:scaling': e => {
        },
        // 旋转对象时触发该事件
        'object:rotating': e => {
        },
        'selection:created': e => {
          if (this.toolType === 'rubber') {
            if (e.target._objects) {
              // 多选删除
              var etCount = e.target._objects.length
              for (var i = 0; i < etCount; i++) {
                this.boardObj.remove(e.target._objects[i])
              }
            } else {
              // 单选删除
              this.boardObj.remove(e.target)
            }
            this.boardObj.discardActiveObject() // 清楚选中框
          }
          this.addHistory()
        }
      })
    },
    drawing () {
      // 判断是否是同一次绘制 是的话先清楚保留最后一次
      if (this.drawingObj) {
        this.boardObj.remove(this.drawingObj)
      }
      this.boardObj.isDrawingMode = false
      this.boardObj.selectable = false
      this.boardObj.selection = false
      let drawObj = null
      switch (this.toolType) {
        case 'pencil':
          this.boardObj.isDrawingMode = true
          break
        case 'line':
          drawObj = this.drawLine()
          break
        case 'dashedLine':
          drawObj = this.drawDashedLine()
          break
        case 'arrow':
          drawObj = this.drawArrow()
          break
        case 'rect':
          drawObj = this.drawRect()
          break
        case 'cricle':
          drawObj = this.drawCricle()
          break
        case 'ellipse':
          drawObj = this.drawEllipse()
          break
        case 'equilateral':
          drawObj = this.drawEquilateral()
          break
        default:
          drawObj = null
          this.boardObj.selection = true
          this.boardObj.skipTargetFind = false
          this.boardObj.selectable = true
          break
      }
      if (drawObj) {
        this.boardObj.add(drawObj)
        this.drawingObj = drawObj
      }
    },
    // 选择工具
    changeTool (type) {
      this.boardObj.isDrawingMode = false
      this.resetDrawObj()
      // 如果有选中的对象先清除选中
      if (this.boardObj.getActiveObject()) {
        this.boardObj.discardActiveObject()
        this.boardObj.renderAll()
      }
      if (type === 'clear') {
        return this.boardObj.clear()
      }
      if (type === 'upload') {
        return
      }
      if (type === 'undo') {
        return this.undo()
      }
      if (type === 'redo') {
        return this.redo()
      }
      if (type === 'download') {
        return this.composeImg()
      }
      this.toolType = type
      if (type === 'pencil') {
        this.boardObj.isDrawingMode = true
      }
      if (type === 'rubber' || type === 'move') {
        this.boardObj.selection = true
        this.boardObj.skipTargetFind = false
        this.boardObj.selectable = true
      }
    },
    resetDrawObj () {
      this.boardObj.selectable = true
      this.boardObj.selection = true
      this.boardObj.skipTargetFind = false
      if (this.textObj) {
        this.textObj.exitEditing()
        this.textObj = null
      }
    },
    // 画实线
    drawLine () {
      return new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
        stroke: this.strokeColor,
        strokeWidth: this.strokeWidth
      })
    },
    // 画虚线
    drawDashedLine () {
      return new fabric.Line(
        [this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y],
        {
          stroke: this.strokeColor,
          strokeWidth: this.strokeWidth,
          strokeDashArray: [10, 3]
        }
      )
    },
    // 画矩形
    drawRect () {
      return new fabric.Rect({
        left: this.mouseFrom.x,
        top: this.mouseFrom.y,
        height: Math.abs(this.mouseTo.y - this.mouseFrom.y),
        width: Math.abs(this.mouseTo.x - this.mouseFrom.x),
        stroke: this.strokeColor,
        strokeWidth: this.strokeWidth,
        fill: 'rgba(255, 255, 255, 0)'
      })
    },
    // 画圆形
    drawCricle () {
      // 计算半径 勾股定理  a^2 + b^2 = c^2
      let a = this.mouseTo.x - this.mouseFrom.x
      let b = this.mouseTo.y - this.mouseFrom.y
      let r = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)) / 2
      return new fabric.Circle({
        left: this.mouseFrom.x,
        top: this.mouseFrom.y,
        stroke: this.strokeColor,
        fill: 'rgba(255, 255, 255, 0)',
        radius: r,
        strokeWidth: this.strokeWidth
      })
    },
    // 画椭圆
    drawEllipse () {
      let left = this.mouseFrom.x
      let top = this.mouseFrom.y
      return new fabric.Ellipse({
        left: left,
        top: top,
        stroke: this.strokeColor,
        fill: 'rgba(255, 255, 255, 0)',
        originX: 'center',
        originY: 'center',
        rx: Math.abs(left - this.mouseTo.x),
        ry: Math.abs(top - this.mouseTo.y),
        strokeWidth: this.strokeWidth
      })
    },
    // 画等边三角形
    drawEquilateral () {
      let height = this.mouseTo.y - this.mouseFrom.y
      return new fabric.Triangle({
        top: this.mouseFrom.y,
        left: this.mouseFrom.x,
        width: Math.sqrt(Math.pow(height, 2) + Math.pow(height / 2, 2)),
        height: height,
        stroke: this.strokeColor,
        strokeWidth: this.strokeWidth,
        fill: 'rgba(255,255,255,0)'
      })
    },
    // 画箭头
    drawArrow () {
      let [sx, sy] = [this.mouseFrom.x, this.mouseFrom.y]
      let [ex, ey] = [this.mouseTo.x, this.mouseTo.y]
      let disY = sy - ey
      let disX = sx - ex
      let theta = 30
      let headlen = 30
      var angle = Math.atan2(disY, disX) * 180 / Math.PI
      var angle1 = (angle + theta) * Math.PI / 180
      var angle2 = (angle - theta) * Math.PI / 180
      var topX = headlen * Math.cos(angle1)
      var topY = headlen * Math.sin(angle1)
      var botX = headlen * Math.cos(angle2)
      var botY = headlen * Math.sin(angle2)
      var arrowX = sx - topX
      var arrowY = sy - topY
      var path = ' M ' + sx + ' ' + sy
      path += ' L ' + ex + ' ' + ey
      arrowX = ex + topX
      arrowY = ey + topY
      path += ' M ' + arrowX + ' ' + arrowY
      path += ' L ' + ex + ' ' + ey
      arrowX = ex + botX
      arrowY = ey + botY
      path += ' L ' + arrowX + ' ' + arrowY
      return new fabric.Path(path, {
        stroke: this.strokeColor,
        fill: 'rgba(255,255,255,0)',
        strokeWidth: this.strokeWidth
      })
    },
    drawText () {
      let { x, y } = this.mouseFrom
      this.textObj = new fabric.Textbox('', {
        left: x,
        top: y,
        width: '',
        height: '',
        fill: this.strokeColor,
        hasControls: true
      })
      this.boardObj.add(this.textObj)
      this.textObj.enterEditing()
      this.textObj.hiddenTextarea.focus()
      this.addHistory()
    },
    // 增加历史记录
    addHistory () {
      this.history.push(JSON.stringify(this.boardObj))
    },
    // 撤消
    undo () {
      let stack = this.history
      if (this.stage < stack.length) {
        this.boardObj.clear().renderAll()
        this.boardObj.loadFromJSON(stack[stack.length - 1 - this.stage - 1])
        this.boardObj.renderAll()
        this.stage += 1
      }
    },
    // 前进
    redo () {
      let stack = this.history
      if (this.stage > 0) {
        this.boardObj.clear().renderAll()
        this.boardObj.loadFromJSON(stack[stack.length - 1 - this.stage + 1])
        this.boardObj.renderAll()
        this.stage -= 1
      }
    },
    // 合成图片并下载
    composeImg () {
      if (this.boardObj._objects.length > 0) {
        let base64Img = this.boardObj.toDataURL({
          formart: 'png',
          multiplier: 2
        })
        // let bd = base64Img.split(',')
        // let mime = bd[0].match(/:(.*?);/)[1]
        // let bstr = atob(bd[1]); let l = bstr.length; let u8arr = new Uint8Array(l)
        // while (l--) {
        //   u8arr[l] = bstr.charCodeAt(l)
        // }
        // let blobData = new Blob([u8arr], { type: 'image/png' })
        // let objectURL = URL.createObjectURL(blobData)
        // FileSaver.saveAs(blobData, 'sketchpad.png')
        this.$emit('composeImgFun', base64Img)
      } else {
        this.$faild('custom', 'Please complete your signature!')
      }
    },
    uploadImg (e) {
      let imgData = e.target.files[0]
      let reader = new FileReader()
      reader.onload = res => {
        let dataUrl = res.target.result
        let imgObj = new Image()
        imgObj.src = dataUrl
        imgObj.onload = () => {
          console.log('imgObj', imgObj)
          var oImg = new fabric.Image(imgObj)
          oImg.scale(0.5)
          this.boardObj.centerObject(oImg).add(oImg).renderAll()
          // 为了连续两次选择同一张图片不触发onchange事件
          this.$refs.sketchpadUpload.value = ''
        }
      }
      reader.readAsDataURL(imgData)
    },
    resizedataURL (datas, wantedWidth, wantedHeight) {
      return new Promise(async function(resolve,reject) {
        var img = document.createElement('img');
        img.onload = function () {
          var canvas = document.createElement('canvas')
          var ctx = canvas.getContext('2d');
          canvas.width = wantedWidth;
          canvas.height = wantedHeight;
          console.log()
          ctx.drawImage(this,0,0,wantedWidth, wantedHeight)
          var dataURI = canvas.toDataURL();
          resolve(dataURI)
        }
      })
    }
  }
}
</script>
